// agreement
export const SIGN_AGREEMENT = 'sign_agreement';
export const DOWNLOAD_SIGNED_AGREEMENT = 'download_signed_agreement';
export const DOWNLOAD_AGREEMENT_BLANK = 'download_agreement_blank';
export const GET_AGREEMENT_INFO = 'get_agreement_info';
export const CLEAN_AGREEMENT_INFO = 'clean_agreement_info';

// app
export const RESIZE_WINDOW = 'resize_window';

// billing
export const FETCH_BILLING_ADDRESSES = 'fetch_billing_addresses';
export const FETCH_REQUEST_BILLING_INFO = 'fetch_request_billing_info';
export const UPDATE_BILLING_INFO = 'update_billing_info';
export const CREATE_NEW_BILLING_POC = 'create_new_billing_poc';
export const CREATE_NEW_BILLING_ADDRESS = 'create_new_billing_address';

// comments
export const FETCH_REQUEST_COMMENTS = 'fetch_request_comment';
export const POST_COMMENT = 'post_comment';

// countries
export const FETCH_COUNTRIES = 'fetch_countries';
export const FETCH_COUNTRY_STATES = 'fetch_country_states';
export const CLEAR_COUNTRY_STATE = 'clear_country_state';

// devices
export const FETCH_DEVICE_LIST = 'fetch_device_list';
export const CLEAR_DEVICE_LIST = 'clear_device_list';
export const SET_DEVICE_LIST_SEARCH_TERM = 'set_device_list_search_term';

// labs
export const FETCH_AUTHORIZED_LABS = 'fetch_authorized_labs';

// model
export const FETCH_MODEL = 'fetch_model';
export const UPDATE_MODEL = 'update_model';
export const FETCH_MODEL_VERSIONS = 'fetch_model_versions';
export const CLEAR_MODEL = 'clear_model';
export const CHECK_FCC_ID = 'check_fcc_id';
export const CHECK_EXISTED_MODEL = 'check_existed_model';

// notifier
export const SHOW_NOTICE = 'show_notice';
export const HIDE_NOTICE = 'hide_notice';

// payments
export const UPDATE_PAYMENT = 'update_payment';

// preloader
export const PRELOADER_START = 'preloader_start';
export const PRELOADER_FINISH = 'preloader_finish';

// request
export const FETCH_REQUEST = 'fetch_request';
export const CHANGE_REQUEST_FIELD = 'change_request_field';
export const SAVE_REQUEST = 'save_request';
export const CLEAR_REQUEST = 'clear_request';
export const APPROVE_REQUEST = 'approve_request';
export const NEW_REQUEST_INIT = 'new_request_init';
export const CREATE_DEVICE_MODEL = 'create_device_model';
export const FETCH_POCS = 'fetch_pocs';
export const CREATE_NEW_POC = 'create_new_poc';
export const USERS_MANUAL_DOWNLOAD = 'users_manual_download';
export const UPDATE_PUBLICATION_OPTIONS = 'update_publication_options';
export const DOCUMENT_DOWNLOAD = 'document_download';
export const DELETE_DOCUMENT = 'delete_document';
export const UPDATE_REQUEST = 'update_request';
export const UPDATE_DEVICE_MODEL = 'update_device_model';
export const GET_USERS_MANUAL_INFO = 'get_users_manual_info';
export const CLEAN_POC_INFO = 'clean_poc_info';
export const SUBMIT_INITIAL_REQUEST = 'submit_initial_request';
export const SUBMIT_ECO_REQUEST = 'submit_eco_request';
export const WITHDRAW_REQUEST = 'withdraw_request';
export const UNWITHDRAW_REQUEST = 'unwithdraw_request';
export const UPDATE_USERS_MANUAL = 'update_users_manual';
export const UPDATE_REQUEST_STATUS = 'update_request_status';
export const RETURN_TO_EDIT_REQUEST = 'return_to_edit_request';
export const SEARCH_REQUEST = 'search_request';
export const MAKE_LAB_DECISION = 'make_lab_decision';
export const SET_VALIDATION_STATUS = 'set_validation_status';

// requests
export const FETCH_CERTIFICATION_REQUESTS = 'fetch_certification_requests';
export const CLEAR_REQUESTS = 'clear_requests';
export const FETCH_APPROVE_WAITING_REQUESTS = 'fetch_approve_waiting_requests';
export const COUNT_APPROVE_WAITING_REQUESTS = 'count_approve_waiting_requests';
export const FETCH_MODEL_LIST = 'fetch_model_list';
export const FETCH_REQUEST_FOR_TESTING = 'fetch_requests_for_testing';
export const FETCH_UNPAID_REQUESTS = 'fetch_unpaid_requests';

// system
export const GET_SYSTEM_INFO = 'get_system_info';

// tests
export const FETCH_REQUEST_TESTS = 'fetch_request_tests';
export const SEND_TEST_RESULT = 'send_test_result';
export const DOWNLOAD_TEST_REPORT = 'download_test_report';
export const CHANGE_TEST_FIELD = 'change_test_field';
export const FETCH_TEST_REPORTS = 'fetch_test_reports';
export const CLEAR_TESTS = 'clear_tests';
export const UPDATE_REPORT_STATUS = 'update_report_status';

// uploads
export const UPLOAD_SUPPORT_DOC = 'upload_support_doc';
export const UPLOAD_USERS_MANUAL = 'upload_users_manual';
export const ADD_TO_QUEUE = 'add_to_queue';
export const REMOVE_FROM_QUEUE = 'remove_from_queue';
export const CLEAR_QUEUE = 'clear_queue';
export const DELETE_USERS_MANUAL = 'delete_users_manual';
export const DELETE_SUPPORT_DOCUMENT = 'delete_support_document';
export const UPLOAD_TEST_REPORT = 'upload_test_report';
export const DELETE_TEST_REPORT = 'delete_test_report';
export const UPDATE_DOCUMENT_TITLE = 'update_document_title';

// user
export const LOGIN_CAUSEWAY = 'login_causeway';
export const LOGOUT = 'logout';
export const AGREE_TERMS = 'agree_terms';
export const TOGGLE_REQUEST_EDIT_MODE = 'toggle_request_edit_mode';
export const GET_USER_INFO = 'get_user_info';
export const SAVE_USER_TOKEN = 'save_user_token';
export const SET_ACCESS_ERROR_FLAG = 'set_access_error_flag';

// wizard
export const INIT_WIZARD = 'init_wizard';
export const SAVE_WIZARD = 'save_wizard';
export const SUBMIT_WIZARD = 'submit_wizard';
export const CHANGE_WIZARD_STEP = 'change_wizard_step';
export const SUBMIT_WIZARD_STEP = 'submit_wizard_step';
export const CLEAR_WIZARD = 'clear_wizard';



// WEBPACK FOOTER //
// ./src/actions/types.js